import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i1857664392__a" }, [
        _createElementVNode("rect", {
          width: "20",
          height: "20",
          rx: "0"
        })
      ])
    ], -1),
    _createElementVNode("g", { "clip-path": "url(#i1857664392__a)" }, [
      _createElementVNode("path", {
        fill: "#743A3A",
        d: "m10 14.07 4.533 3.358c.095.07.217.09.33.056.186-.056.284-.238.23-.407l-1.737-5.5 4.636-3.456a.322.322 0 0 0 .133-.257c0-.179-.154-.33-.354-.332l-5.703-.008L10.34 2.11a.343.343 0 0 0-.23-.22c-.193-.058-.394.045-.45.22L7.932 7.524l-5.703.01c-.111-.002-.216.048-.286.135a.314.314 0 0 0 .065.452l4.636 3.456-1.738 5.5a.31.31 0 0 0 .053.287.372.372 0 0 0 .508.064L10 14.071Zm-3.79 4.363a1.621 1.621 0 0 1-2.237-.301 1.56 1.56 0 0 1-.26-1.431l1.471-4.654-3.923-2.925A1.564 1.564 0 0 1 .96 6.897a1.614 1.614 0 0 1 1.267-.614l4.791-.007L8.47 1.73A1.61 1.61 0 0 1 10.472.696c.502.15.898.537 1.06 1.035l1.45 4.544 4.792.008a1.592 1.592 0 0 1 1.602 1.583 1.572 1.572 0 0 1-.637 1.256l-3.923 2.925 1.47 4.654a1.576 1.576 0 0 1-1.064 1.98c-.49.147-1.02.055-1.432-.248L10 15.626l-3.79 2.807Z"
      })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "simplicity"}) } }